import { useModal } from '@bitstopco/bitstop-theme';
import { IconButton } from '@mui/material';

import { HiMiniKey } from 'react-icons/hi2';

import type { User } from '@/types';

interface UsersResetPasswordColumnV2Props {
  data: Pick<User, 'id' | 'email'>;
}

export const UsersResetPasswordColumnV2 = ({ data }: UsersResetPasswordColumnV2Props) => {
  const { show } = useModal();

  const handleResetPassword = () => {
    show('user-reset-password-v2', data);
  };

  return (
    <IconButton onClick={handleResetPassword} data-test="users-v2-reset-password-btn">
      <HiMiniKey size={18} />
    </IconButton>
  );
};
